var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.4C0 3.23305 0.46357 2.11389 1.28873 1.28873C2.11389 0.46357 3.23305 3.04727e-08 4.4 3.04727e-08H20.9C21.9672 -0.000125506 22.9981 0.387624 23.8007 1.09104C24.6032 1.79446 25.1228 2.76559 25.2626 3.8236L32.1046 0.7832C32.4395 0.633977 32.8064 0.57082 33.1719 0.599468C33.5374 0.628116 33.89 0.747661 34.1975 0.947237C34.5051 1.14681 34.7579 1.42009 34.933 1.74223C35.1081 2.06437 35.1998 2.42516 35.2 2.7918V19.2082C35.1997 19.5746 35.1079 19.935 34.9329 20.2569C34.758 20.5788 34.5054 20.8519 34.1981 21.0514C33.8909 21.2509 33.5387 21.3705 33.1735 21.3994C32.8082 21.4283 32.4416 21.3655 32.1068 21.2168L25.2626 18.1764C25.1228 19.2344 24.6032 20.2055 23.8007 20.909C22.9981 21.6124 21.9672 22.0001 20.9 22H4.4C3.23305 22 2.11389 21.5364 1.28873 20.7113C0.46357 19.8861 0 18.767 0 17.6V4.4Z",
    fill: "#710D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/video-call-icon.5b37ab571927369f299753c52e017afa.svg";
export { ForwardRef as ReactComponent };